import React from 'react';
import { Checkbox, Box, Typography } from '@mui/material';

function CheckboxComponent(props) {
  // Info
  const id = props.id;
  const input = props.handler.form[id];
  const label = input.label;
  const orientation = props.orientation ?? 'right';

  // Value
  const [value, setValue] = React.useState(false);

  React.useEffect(() => {
    if (input.value !== undefined && input.value !== value) setValue(!!input.value);
  }, [input.value, value]);

  const onChange = () => {
    const newValue = !value;
    setValue(newValue);
    props.handler.setValue(id, newValue);
    if (props.onChange) props.onChange(newValue);
  };

  return (
    <Box
      style={props.style}
      sx={{
        width: '100%', textAlign: 'left', marginTop: 0,
        height: 55, color: 'rgba(0, 0, 0, 0.6)',
      }}
    >
      {orientation === 'left' && (
        <Typography
          component="span"
          sx={{
            color: 'rgba(0, 0, 0, 0.6)', display: 'inline-block',
            cursor: 'pointer', verticalAlign: 'middle',
          }}
        >
          {label}
        </Typography>
      )}
      <Checkbox
        checked={value}
        onChange={onChange}
        disabled={input.disabled || props.disabled}
        sx={{
          color: '#e91e63',
          '&.Mui-checked': {
            color: '#81c881',
          },
        }}
      />
      {orientation === 'right' && (
        <Typography
          component="span"
          sx={{
            color: 'rgba(0, 0, 0, 0.6)', display: 'inline-block',
            cursor: 'pointer', verticalAlign: 'middle',
          }}
        >
          {label}
        </Typography>
      )}
      {(input && input.textHelper) && <Typography
        sx={{
          margin: '-4px 14px', fontSize: 9, minHeight: 9,
          lineHeight: '9px', color: 'rgba(0, 0, 0, 0.6)', fontWeight: 400,
        }}
      >
        {input.textHelper}
      </Typography>}
    </Box>
  );
}

export default CheckboxComponent;
